import React from 'react';
import { ActionBarItem, IActionBarItemData, IActionBarItemClick } from './ActionsBarItem';

export interface IActionBarItems {
  actions: IActionBarItemData[];
  actionClassName?: string;
  onClick: IActionBarItemClick;
}

export function ActionBarItems({ actions, actionClassName: className, onClick }: IActionBarItems) {
  return (
    <>
      {(actions || []).map(action => (
        <ActionBarItem key={action.id} item={action} className={className} onClick={onClick} />
      ))}
    </>
  );
}
